import mountReactApp from 'mount-react-app';
import {routes, reducers} from 'bus-dweb';
// import App from 'hotels-dweb';

function renderApp() {
  mountReactApp({routes, reducers});
}

renderApp();

// if (module.hot) {
//   module.hot.accept('hotels-dweb', () => renderApp());
// }
